import searchAutocompleteHtml from './searchautocomplete.html';
import './searchautocomplete.scss';

class SearchAutocompleteController {
    constructor($scope, $timeout, SearchAutocompleteService) {
        'ngInject';

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.service = SearchAutocompleteService;
        this.loading = false;
        this.query = '';
        this.options = [];
        this.debounce = null;
        this.redirect = false;
    }

    $onInit() {
        this.$scope.$watch(
            () => this.query,
            () => {
                this.refreshMatches();
            }
        );
    }

    refreshMatches() {
        this.loading = true;
        this.options = [];

        if (this.debounce) {
            this.$timeout.cancel(this.debounce);
            this.debounce = null;
        }

        if (this.query == '') {
            this.loading = false;
            this.options = [];

            return;
        }

        this.debounce = this.$timeout(() => {
            this.service.matches(this.query).then(
                (response) => {
                    this.loading = true;
                    this.options = response.data.map(option => {
                        if (option.variant_name && option.variant_name != '')
                            option.name = `${option.name} (${option.variant_name})`;

                        return option;
                    });
                },
                () => {
                    this.loading = false;
                }
            );
        }, 500);

    }

    submit(query) {
        this.redirect = true;
        window.location.href = '/szukaj/' + encodeURI(query);
    }

    select(match) {
        this.redirect = true;
        window.location.href = match.link;
    }
}

let searchAutocompleteComponent = {
    bindings: {},
    template: searchAutocompleteHtml,
    controller: SearchAutocompleteController
}

export default searchAutocompleteComponent;